<template>
    <div id="s-subElementSelector">

        <b-row class="justify-content-center">
                <b-button v-if="content.length > 0" class="btnShow" @click="$bvModal.show(name)">{{title}} {{selectItemText}} </b-button>
        </b-row>
    
            <b-modal :body-bg-variant="getTheme.light" :header-bg-variant="getTheme.dark" :header-text-variant="getTheme.light" :id="name" :title="title" hide-footer>
                <!--SOUS-TITRE / PROGRESS BAR -->
                <h6 class="showId">
                    <span v-if="sendMsg=='-'">
                        <b-spinner small type="grow" :variant="getTheme.warning"></b-spinner>
                        <b-spinner small type="grow" :variant="getTheme.danger"></b-spinner>
                        <b-spinner small type="grow" :variant="getTheme.warning"></b-spinner>
                        <b-spinner small type="grow" :variant="getTheme.danger"></b-spinner>
                        <b-spinner small type="grow" :variant="getTheme.warning"></b-spinner>
                    </span>                
                    <span v-else-if="sendMsg=='1'" @click="msg=''">
                        <span class="txtSize">{{$t('g_Ok')}}</span>
                    </span>  
                    <span v-else-if="status=='2'" @click="msg=''">
                        <span class="txtSize">{{$t('g_Erreur')}}</span>
                    </span>   
                </h6>
                
                <!--AJOUTER-->
                <b-row class="addLicContainer">
                    <b-form-input class="txtLeft" :maxlength="addLength" id="addItem" name="addItem" type="text" :placeholder="$t('g_Nouveau') + ' : ' + title" v-model="addValue"></b-form-input>
                    <b-button type="button" class="btnLeft" @click="menuSave()">{{$t('g_Ajouter')}}</b-button>
                </b-row>

                <!--RECHERCHE-->
                <b-row class="addLicContainer">
                    <b-form-input class="txtLeft" id="search" name="search" type="text" :placeholder="$t('g_Recherche')" v-model="txtRecherche"></b-form-input>
                    <b-button type="button" class="btnLeft" @click="txtRecherche = '', addValue = ''">{{$t('g_Efface')}}</b-button>
                </b-row>

                <!--CONTENU-->
                <div class="scroll borderMain">

                    <b-list-group style="margin-top: 5px">
                            <b-list-group-item class="cursorPoint btnRemove" @click="handleInput(0, '')"><span>{{$t('g_Aucun')}}</span></b-list-group-item>
                            <b-list-group-item :class="item[returnField] == selectedItems ? 'cursorPoint btnStylSelected' : 'cursorPoint btnStyle'" v-for="(item) in recherche" :key="item.index" @click="handleInput(item[returnField], item[showField], txtRecherche='')">
                               <span>{{item[showField]}}</span>
                            </b-list-group-item>
                    </b-list-group>

                </div>
            </b-modal>
        </div>
    
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios';
//import api from '@/services/api.js';
import {userService, tokenService} from '@/services'

export default{
    name: 's-subElementSelector',
    props: {
        name: String,
        title: String,
        content: null,
        showField: String,
        returnField: String,
        selectedItems: null,
        apiAdd1: String,
        saveValue: String,
        addLength: String
    },
    data() {
        return {
            sendMsg: '',
            txtRecherche: '',
            selectItemText: '',
            addValue: ''
        }
    },
    methods: {
        handleInput(valeur, itemText) {
            this.selectItemText = itemText
            this.$emit('update:returnValue', valeur)
            this.$bvModal.hide(this.name)
        },
        AddInput() {
            this.$emit('update:returnAddValue', this.content)
        },
        getSelectedText(itemNumber){
            var i;
            if (i == 0)
            {
                return ''
            }
            else
            {
                for (i = 0; i < this.content.length; i++) {
                if (this.content[i].id == itemNumber)
                {return this.content[i][this.showField]}
                }
            }
            return '---'
        },
        menuSave(){
            this.sendMsg = '-'
            let currentObj = this

            const getCurrentLicence = userService.getLicence()
            const token = tokenService.getToken()
            let apiUrl = this.apiAdd1 +'?licence=' + getCurrentLicence
            let obj = {
                [this.saveValue]: currentObj.addValue,
            }
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + token
                }
            }

            axios.post(apiUrl, obj, config)
            .then((response) => {
                this.sendMsg = '1'
                this.content.unshift(response.data.data)
                this.AddInput()
            })
            .catch((error) => {
                this.sendMsg = '2'
                this.output = error;
            });
             
            setTimeout(() => { this.sendMsg = '' }, 3000)

            this.addValue = ''
        }
    },
    computed: {
        ...mapGetters(['getTheme']),
        status() {
            return this.value
        },
        recherche() {
            const search = this.txtRecherche.toLowerCase().trim();
            if (!search) return this.content
            return this.content.filter(c => c[this.showField].toLowerCase().indexOf(search) > -1);
        },

    },
    watch: {
        selectedItems: function() {
            if (this.selectedItems == -1 || this.selectedItems == 0)
            {this.selectItemText = ''}
            else
            {this.selectItemText = ' : ' + this.getSelectedText(this.selectedItems)}
        }
    }    
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/components/subElementSelector.scss'

</style>